
(function () {
    'use strict';

    angular
        .module('controlModule')
        .directive('grcControl', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {

        var directiveScope = _.clone(boxTmplScope);
        directiveScope.addControl = '&';
        directiveScope.unlinkControl = '&';
        directiveScope.layoutRatio = '=?';
        directiveScope.highlight = '=';
        directiveScope.hideClosed = "=";
        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller', '$filter', 'authenticatedUserService', 'permissionService', 'grcControlService',
                function ($rootScope, $scope, $controller, $filter, authenticatedUserService,permissionService, grcControlService) {

                // Box Template
                $scope.baseTemplatePath = '/app/shared/grc/control/grcControl.[Template].tpl.html';
                // Permissions default values
                    $scope.boxFeatureRole = $scope.boxFeatureRole || 'ControlGrpBusinessUnit_GovernanceManagement';
                $scope.boxPermissionKey = $scope.boxPermissionKey || 'Control';

                $controller('BoxTmplController', { $scope: $scope });

                $scope.canEdit = $scope.boxPermissions.Edit;

                // Get Control Lookups
                grcControlService.getAllLookups()
                    .then(function (lookups) {
                        $scope.controlLookups = lookups;
                    });

                // Page is dirty
                $scope.ctxtCtrl = {};
                $scope.ctxtCtrl.needSaveChanges = false;

                $scope.pageIsDirty = function () {
                    $scope.ctxtCtrl.needSaveChanges = true;
                    $rootScope.$broadcast('page-is-dirty');
                };
                $scope.pageIsNotDirty = function () {
                    $scope.ctxtCtrl.needSaveChanges = false;
                    $rootScope.$broadcast('page-is-not-dirty');
                };

                // Control loading
                $scope.isLoading = false;

                // Go To Control
                $scope.goToControl = function () {
                    $scope.clickOnBox();
                };

                // Get ARIC Assessment
                $scope.getControlToAssess = function () {
                    return boxModel.ControlAssessment;
                };
                
                // When selected control
                $scope.whenSelectedControl = function (control) {
                    $scope.addControl({ control: control });
                };

                // To unlink control
                $scope.toUnlinkControl = function (control, $event) {
                    $event.stopPropagation();

                    if (!_.isUndefined($scope.unlinkControl)) {
                        $scope.unlinkControl()(control);
                    }
                };

                // Unlink column
                $scope.getUnlinkColumn = function () {
                    var defaultUnlinkColumn = undefined;

                    if (_.isUndefined($scope.layoutRatio)) return defaultUnlinkColumn;
                    if (_.isUndefined($scope.layoutRatio.unlinkColumn)) return defaultUnlinkColumn;

                    return $scope.layoutRatio.unlinkColumn;
                };
            }],

            link: function (scope, elem, attrs) {

                boxTmplLinkFn(scope, elem, attrs);

                scope.$watch('boxModel', function (newValue) {
                    if (!newValue) return;

                    if (!_.isUndefined(scope.boxModel.ImplementationDate)) {
                        scope.boxModel.ImplementationDate = moment(scope.boxModel.ImplementationDate).format();
                    }
                });
            }
        }
    }
})();